import React from "react";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import classnames from "classnames";

import SanitizedText from "shared/components/SanitizedText";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import Report, { TYPES } from "shared/util/Report";
import MarkMessageAsRead from "shared/util/MarkMessageAsRead";
import {
	getPhotoUrl,
	getEssayText,
} from "shared/util/ProfileComment";

import withMessenger from "apps/messenger/containers/withMessenger";

import "./FirstMessage.scss";

const FirstMessage = ({
	profileComment,
	body,
	messageid,
	threadid,
	userid,
	username,
	shouldOpenMessage,
	openConversation,
	showInstructionTooltip,
}) => {
	const photoUrl = getPhotoUrl(profileComment);
	const essayContent = getEssayText(profileComment);

	const classes = classnames({
		"firstmessage2017": true,
		"firstmessage2017--openmessage": shouldOpenMessage,
		"firstmessage2017--comment": profileComment,
		"firstmessage2017--comment--photo": photoUrl,
		"firstmessage2017--comment--essay": essayContent,
	});

	const _openMessage = (ev) => {
		if (shouldOpenMessage) {
			ev.preventDefault();
			ev.stopPropagation();

			openConversation(userid);
		}
	};

	const _openReport = (ev) => {
		ev.preventDefault();
		ev.stopPropagation();
		Report.open({
			type: TYPES.MESSAGE,
			threadid,
			userid,
			username,
		});
	};

	MarkMessageAsRead(userid, messageid);

	const wrapperProps = {};

	if (showInstructionTooltip) {
		wrapperProps["data-tooltip"] = _str("Want to reply? You have to like them first (so they know you really care).");
	}

	return (
		<div id="firstmessage2017" className={classes} {...wrapperProps}>
			{photoUrl &&
				<div className="firstmessage2017-comment-content photo">
					<img src={photoUrl} alt="" />
				</div>
			}
			{essayContent &&
				<SanitizedText
					className="firstmessage2017-comment-content essay"
					text={essayContent}
				/>
			}
			<Str className="firstmessage2017-heading">
				They wrote you an intro
			</Str>
			<button className="firstmessage2017-flag" onClick={_openReport}>
				<i className="okicon i-report" />
			</button>
			<div
				className="firstmessage2017-body"
				onClick={_openMessage}
				role="button"
				tabIndex={0}
			>
				<SanitizedText
					className="firstmessage2017-body-text"
					text={body}
				/>
			</div>
		</div>
	);
};

FirstMessage.propTypes = {
	userid: PropTypes.string.isRequired,
	username: PropTypes.string.isRequired,
	threadid: PropTypes.string,
	messageid: PropTypes.string,
	profileComment: PropTypes.object,
	body: PropTypes.string.isRequired,
	shouldOpenMessage: PropTypes.bool,
	openConversation: PropTypes.func,
	showInstructionTooltip: PropTypes.bool,
};

FirstMessage.defaultProps = {
	messageid: null,
	threadid: null,
	profileComment: null,
	shouldOpenMessage: false,
	openConversation: null,
	showInstructionTooltip: false,
};

const FirstMessageWithMessenger = withMessenger(FirstMessage);

FirstMessageWithMessenger.fragments = {
	message: gql`
		fragment FirstMessage on Match {
			senderLikes
			senderPassed
			firstMessage {
				id
				threadId
				text
				profileComment {
					... on ProfileCommentPhoto {
						photo {
							square800
						}
					}
					... on ProfileCommentEssay {
						essayTitle
						essayText
					}
					... on ProfileCommentInstagramPhoto {
						instagramPhoto {
							square640
						}
					}
					... on ProfileCommentQuestion {
						questionText
						targetAnswer
						targetExplanation
					}
				}
			}
		}
	`,
};

export default FirstMessageWithMessenger;



// WEBPACK FOOTER //
// ./src/shared/components/FirstMessage.jsx